import {
  coverStory,
  leadCards,
  statHighlights,
} from "@/mocks/expose";

export default function Hero() {
  return (
    <section id="top" className="mx-auto max-w-page px-4 pb-2 pt-8 md:px-6 md:pt-12">
      {/* —— 稀疏的杂志版头 —— */}
      <div className="text-center">
        <p className="text-xs tracking-[0.35em] text-foreground-500">
          深挖档案 · 总第 09 期 &nbsp;/&nbsp; VOL.09 &nbsp;/&nbsp; {coverStory.date}
        </p>
        <h1 className="mt-3 font-heading text-4xl font-black tracking-tight text-foreground-950 md:text-6xl">
          呱呱<span className="text-primary-600">爆料</span>
        </h1>
        <p className="mt-4 text-xs text-foreground-500 md:text-sm">
          真实身份 · 背后金主 · 隐藏关系 · 私下聊天 · 未公开信息 —— 从蛛丝马迹，拼出一个完整的人。
        </p>
        <div className="mx-auto mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#feed"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-radar-line text-base"></i>
            开始深挖
          </a>
          <a
            href="#topics"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-400"
          >
            <i className="ri-question-answer-line text-base text-accent-600"></i>
            去话题墙看看
          </a>
        </div>
      </div>

      <div className="my-6 flex items-center gap-3 text-foreground-400">
        <span className="h-px flex-1 bg-foreground-900/10"></span>
        <span className="h-px flex-1 bg-foreground-900/10"></span>
      </div>

      {/* —— 多卡并列首屏 —— */}
      <div className="grid gap-6 lg:grid-cols-3">
        {/* 封面深挖：标题优先、留白克制 */}
        <article className="relative overflow-hidden rounded-lg border border-background-200/80 bg-background-100 p-6 md:p-8 lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="rounded bg-primary-500 px-2 py-1 text-[11px] font-semibold text-background-50">
              {coverStory.kicker}
            </span>
            <span className="text-xs text-foreground-500">
              {coverStory.byline} · {coverStory.readTime}
            </span>
          </div>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            {coverStory.title}
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-600 md:text-[15px]">
            {coverStory.stand}
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-2">
            {coverStory.tags.map((t) => (
              <span
                key={t}
                className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700"
              >
                #{t}
              </span>
            ))}
            <span className="ml-auto flex items-center gap-3 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-line"></i> 24.6 万
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-chat-3-line"></i> 4,830
              </span>
            </span>
          </div>
          <a
            href="#archive"
            className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600"
          >
            进入完整时间线
            <i className="ri-arrow-right-line"></i>
          </a>
        </article>

        {/* 并列速览小卡 */}
        <div className="grid gap-3">
          {leadCards.map((c, i) => (
            <article
              key={c.title}
              className="rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-2">
                <span className="font-heading text-xl font-black text-secondary-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-xs text-foreground-500">{c.kicker}</span>
                {c.trend && (
                  <span className="rounded bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-800">
                    上升
                  </span>
                )}
                {c.hot && (
                  <span className="rounded bg-primary-100 px-1.5 py-0.5 text-[10px] font-medium text-primary-700">
                    热
                  </span>
                )}
              </div>
              <h3 className="mt-2 text-sm font-medium leading-6 text-foreground-900 line-clamp-3">
                {c.title}
              </h3>
              <p className="mt-2 text-[11px] text-foreground-500">{c.meta}</p>
            </article>
          ))}
        </div>
      </div>

      {/* 实时数据带：accent 直给时刻 */}
      <div className="mt-6 grid grid-cols-2 gap-3 border-y border-background-200/70 py-5 md:grid-cols-4">
        {statHighlights.map((s, idx) => (
          <div key={s.label} className="text-center md:text-left">
            <p className="text-3xl font-black tabular-nums text-foreground-950 md:text-4xl">
              {s.value}
              <span className={idx === 2 ? "text-accent-600" : "text-primary-600"}>
                {s.unit}
              </span>
            </p>
            <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}